import { z } from "zod";

/**
 * The index's search, in the address so Back and a reload keep it. Apart from `schemas.ts`, so the
 * route's search check does not bring the feature's words into every screen's first load.
 */
export const notesSearch = z.object({
  q: z.string().trim().min(1).max(100).optional().catch(undefined),
});
